import RestClient from './rest-client'

export default class CarrierSetting extends RestClient {
  static get url () {
    return this.apiUrl + '/carrier_settings'
  }

  static get paramKey () {
    return 'carrier_setting'
  }

  static async HiddenData (data) {
    let keys = ['key','password','client_id','client_secret','rate_secret','rate_password','customer_number']
    data.map((item) => {  
      if (item.key.includes('_id') || item.key.includes('key') || item.key.includes('password') || item.key.includes('secret')) {
        item.hidden = true
      }else{
        if (keys.includes(item.key)) {
          item.hidden = true
        } else {
          item.hidden = false
        }
      }      
      return item
    })
    return data
  }

  static async exportLimitLogs (params) {
    const { data } = await this.http({
      url: this.url + '/export_limit_logs',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }
}
